/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext } from "react";
import { type PeriodFilterValue, usePeriodFilter } from "@/hooks/usePeriodFilter";

const PeriodFilterContext = createContext<PeriodFilterValue | undefined>(undefined);

export function PeriodFilterProvider({ children }: { children: React.ReactNode }) {
  const periodFilter = usePeriodFilter();
  return <PeriodFilterContext.Provider value={periodFilter}>{children}</PeriodFilterContext.Provider>;
}

export function usePeriodFilterContext() {
  const context = useContext(PeriodFilterContext);
  if (!context) {
    throw new Error("usePeriodFilterContext must be used within PeriodFilterProvider");
  }

  return context;
}
